/* eslint-disable max-len, vue/max-len */
import { defineAsyncComponent } from 'vue';
import lang from '@/client_customs/Baccarat/lang.js';
import { createTableHeaders } from '@/client_customs/Baccarat/portfolioTableHeaders.js';

const BaccaratProjectSheetHeader = defineAsyncComponent(() => import('@/client_customs/Baccarat/BaccaratProjectSheetHeader.vue'));
const BaccaratProjectSheetWaypoints = defineAsyncComponent(() => import('@/client_customs/Baccarat/BaccaratProjectSheetWaypoints.vue'));
const BaccaratDashboardProjectsFilters = defineAsyncComponent(() => import('@/client_customs/Baccarat/BaccaratDashboardProjectsFilters.vue'));
const BaccaratPortfolioRow = defineAsyncComponent(() => import('@/client_customs/Baccarat/BaccaratPortfolioRow.vue'));
const BaccaratPortfolioColsFilter = defineAsyncComponent(() => import('@/client_customs/Baccarat/BaccaratPortfolioColsFilter.vue'));
const BaccaratHomeProjectsFilters = defineAsyncComponent(() => import('@/client_customs/Baccarat/BaccaratHomeProjectsFilters.vue'));

const categoriesLists = [
  ['ART TABLE', 'BIJOUX', 'DECO', 'DIV', 'INNO', 'LUMINAIRE', 'PART. STRAT.'],
  ['CONCEPTION', 'DESIGN', 'DESIGN FREEZE', 'IDEATION', 'INDUSTRIALISATION', 'PRODUCTION', 'RETEX'],
  ['AU PLAN', 'EN COURS', 'CLOTURE', 'ABANDONNE', 'NC - devis non communiqué', 'CM - Devis communiqué', 'CN - Confirmé', 'LI -Livré'],
];

export default {
  subdomain: 'baccarat',
  clientCustomComponents: { BaccaratProjectSheetHeader, BaccaratProjectSheetWaypoints, BaccaratDashboardProjectsFilters, BaccaratPortfolioRow, BaccaratPortfolioColsFilter, BaccaratHomeProjectsFilters },
  lang,
  sso: {
    protocol: 'openIDConnect',
    login: 'https://login.microsoftonline.com/64079cd0-2318-4789-95e3-36315b96e351/oauth2/v2.0/authorize?client_id=2e38c391-23c6-49a3-8083-340eccc95c1e&response_type=code&scope=openid%20email%20profile&redirect_uri=https%3A%2F%2Fbaccarat.bubbleplan.net',
    response_type: 'code',
  },
  hideManageAccount: true,
  datePicker: { showWeek: true },
  projectsheet: {
    headerCustomField: { component: 'BaccaratProjectSheetHeader' },
    waypointsCustomField: { component: 'BaccaratProjectSheetWaypoints' },
    customTargetsList: [
      { path: 'customFields', id: 'goindus', type: 'date', label: 'Date GO INDUS', icon: 'far fa-hourglass-end', getCompareValue() { return this.planning.elements?.find(item => item.getTitle().trim().toUpperCase() === 'GO INDUS')?.getEndTime(); } },
      { path: 'customFields', id: 'dispomoule', type: 'date', label: 'Dispo MOULE', icon: 'far fa-hourglass-end', getCompareValue() { return this.planning.elements?.find(item => item.getTitle().trim().toUpperCase() === 'DISPO MOULE')?.getEndTime(); } },
      { path: 'customFields', id: 'bat', type: 'date', label: 'Date BAT', icon: 'far fa-hourglass-end', getCompareValue() { return this.planning.elements?.find(item => item.getTitle().trim().toUpperCase() === 'BAT')?.getEndTime(); } },
    ],
  },
  dashboards: {
    customProjectsFilters: { component: 'BaccaratDashboardProjectsFilters', value: {} }, // value is used as a store
  },
  kanban: {
    showPlannedMilestonesInBacklog: true,
  },
  projects: {
    categoriesANDFilter: true,
    customHomeProjectsFilters: { component: 'BaccaratHomeProjectsFilters' },
  },
  portfolio: {
    getTableHeaders: () => createTableHeaders(categoriesLists),
    customColsFilter: { component: 'BaccaratPortfolioColsFilter' },
    hideProjectOwnersFilter: true,
  },
  categories: {
    dynamicList(selectedTags, mode = 'filter') {
      const set1 = new Set(this.lists[0]);
      const set2 = new Set(this.lists[1]);
      const set3 = new Set(this.lists[2]);
      const hasSet1 = selectedTags?.some(tag => set1.has(tag));
      const hasSet2 = selectedTags?.some(tag => set2.has(tag));
      const hasSet3 = selectedTags?.some(tag => set3.has(tag));
      if (mode == 'filter') {
        const list = [];
        if (! hasSet1) list.push(...set1);
        if (! hasSet2) list.push(...set2);
        if (! hasSet3) list.push(...set3);
        return list;
      }
      // mode == 'sort'
      const list = [];
      if (! hasSet1) list.push(...set1);
      if (! hasSet2) list.push(...set2);
      if (! hasSet3) list.push(...set3);
      if (hasSet1) list.push(...set1);
      if (hasSet2) list.push(...set2);
      if (hasSet3) list.push(...set3);
      return list;
    },
    lists: categoriesLists,
  },
  categoryColors: {
    'ART TABLE': '003366', // darkest blue
    BIJOUX: '004080',
    DECO: '00509E',
    DIV: '0066CC',
    INNO: '0073E6',
    LUMINAIRE: '007FFF',
    'PART. STRAT.': '3388CC', // lightest blue

    CONCEPTION: '27AE60', // darkest green
    DESIGN: '52BE80',
    'DESIGN FREEZE': '82E0AA',
    IDEATION: 'B2F5CB',
    INDUSTRIALISATION: 'C8F7DC',
    PRODUCTION: 'D4EFDF',
    RETEX: 'E9FFEF', // lightest green

    'AU PLAN': '8B0000', // darkest red
    'EN COURS': 'B22222',
    CLOTURE: 'DC143C',
    ABANDONNE: 'E74C4C',
    'NC - devis non communiqué': 'FF7F7F',
    'CM - Devis communiqué': 'FFA3A3',
    'CN - Confirmé': 'FFC0CB',
    'LI -Livré': 'FFD6DD', // lightest red
  },
};
